import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Option } from '@telespot/protocols/data-access';

@Component({
    selector: 'ts-label-selection-panel',
    templateUrl: './label-selection-panel.component.html',
    styleUrls: ['./label-selection-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LabelSelectionPanelComponent {
  @Input() public readonly labels: Option[];

  @Output() public readonly clearLabel = new EventEmitter<string>();
  @Output() public readonly clearAll = new EventEmitter<void>();
}
